import { CustomLink } from '../../../common/CustomLink'
import { Element } from '../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { COMPONENTS } from '../../../routers/constants'

export const ItemLink = ({ item }) => {
  const formatHref = `${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${item?.organizationId}`

  if (!item) return <div>&nbsp;</div>
  return (
    <CustomLink to={formatHref} target="_blank">
      <Element style={{ color: '#2C73E8' }}>
        <TextEllipsisStaticLine
          lineClamp={1}
          text={item.organizationName}
          isI18n={false}
        />
      </Element>
    </CustomLink>
  )
}
